module.exports = __webpack_public_path__ + "img/bg3.415a679f.png";